import script from "./TradeTransactionConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradeTransactionConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./TradeTransactionConfirm.vue?vue&type=style&index=0&id=01085ae5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01085ae5"]])

export default __exports__